/**
 * @author Rahul Nainala
 * @description This Component is mainly for Converting File to Base64
 * React File Base64 - Version@1.0.1
 */

import React from 'react';

const FileBase64 = ({ multiple, onDone }) => {

    const handleChange = (e) => {
        const files = e.target.files;

        const allFiles = [];

        Array.from(files).forEach((file) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = () => {
                const fileInfo = {
                    name: file.name,
                    type: file.type,
                    size: Math.round(file.size / 1000) + 'kB',
                    base64: reader.result,
                    file: file,
                };

                allFiles.push(fileInfo);

                if (allFiles.length === files.length) {

                    if (multiple) {
                        onDone(allFiles);
                    } else {
                        onDone(allFiles[0]);
                    }
                }
            };
        });
    };
    return (
        <input
            type='file'
            onChange={handleChange}
            multiple={multiple}
        />
    );
};

FileBase64.defaultProps = { multiple: false };

export default FileBase64;